import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import get from 'lodash/get';
import { FMessage } from '../../hoc/IntlComponents';
import Icon from '../Icon/Icon';

const StreamTDSHintContent = ({data, landings, transits, offerObjError}) => (
  <Fragment>
    <Row>
      {offerObjError && <Icon type='fire' />}
      <Col lg='4' className='label'>
        <FMessage id="streamTDS.hint.offer"/>
      </Col>
      <Col lg='8' className='content'>
        {
          offerObjError ?
            <FMessage id={`streamTDS.hint.${offerObjError}`}/>
            :
            <a
              href={`/offers/${get(data, 'offerId')}`} target='_blank'>
                {get(data, 'offerTitle')}
            </a>
        }
      </Col>
    </Row>
    <Row>
      <Col lg='4' className='label'>
        <FMessage id="streamTDS.hint.link"/>
      </Col>
      <Col lg='8' className='content'>
        <a
          href={get(data, 'flowLink')} target='_blank'>
            {get(data, 'flowLink')}
        </a>
      </Col>
    </Row>
    {!offerObjError && landings.length > 0 ?
      <Row>
        <Col lg='4' className='label'>
          <FMessage id="streamTDS.hint.landings"/>
        </Col>
        <Col lg='8' className='content'>
          {
            landings.map((land, key) =>
              <div key={key}>
                <a href={land.url} target='_blank'>{land.title}</a>
              </div>
            )
          }
        </Col>
      </Row> : null
    }
    {!offerObjError && transits.length > 0 ?
      <Row>
        <Col lg='4' className='label'>
          <FMessage id="streamTDS.hint.transits"/>
        </Col>
        <Col lg='8' className='content'>
          {
            transits.map((trans, key) =>
              <div key={key}>
                <a href={trans.url} target='_blank'>{trans.title}</a>
              </div>
            )
          }
        </Col>
      </Row> : null
    }
  </Fragment>
);

export default StreamTDSHintContent;